import React from 'react';
import { PvInput } from 'styles/CustomComponents';

export const PvInputWrapper = (props) => (
  <PvInput
    {...props}
    onBlur={() => props.input.onBlur(props.input.value)}
    onChange={props.input.onChange}
    value={props.input.value}
  />
);



// WEBPACK FOOTER //
// ./src/components/form/PvInputWrapper.jsx